var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.36,
    height: 22.76,
    viewBox: "0 0 17.36 22.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "default_document_icon",
    "data-name": "default document icon",
    transform: "translate(-16 -225.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Default_icon",
    "data-name": "Default icon",
    transform: "translate(-32 37.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M18.35,22.08a.681.681,0,0,1-.67.69H1.67A.681.681,0,0,1,1,22.08V.7A.681.681,0,0,1,1.67.01H13.48c.87.93,4.51,4.47,4.88,4.94V22.07Z",
    transform: "translate(47 187.99)",
    fill: "#e0f4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2052",
    "data-name": "Path 2052",
    d: "M13.51.02V4.31a.628.628,0,0,0,.62.61h4.18Z",
    transform: "translate(47 187.99)",
    fill: "#99badb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultColorIcon);
export default __webpack_public_path__ + "static/media/default-color-icon.5e7c2a74fdbdb889e80a5821e08777db.svg";
export { ForwardRef as ReactComponent };